module.exports = __webpack_public_path__ + "static/media/farm_pharm_13.5ffdc11c.jpg";